import { AssignmentResponse } from '@/types';
import { WorkflowButton } from './WorkflowButton';

import { FileAudio } from 'lucide-react';
import { useAtomValue, useSetAtom } from 'jotai';
import {
  assignmentDraftsAtom,
  createDraftActionAtom,
  draftsLoadingAtom,
  fetchDraftsActionAtom,
} from '@/stores';
import { useEffect } from 'react';
import { Drafts } from '../drafts/Drafts';

type DraftBlockProps = {
  assignment: AssignmentResponse;
  isDetailsPage?: boolean;
};

export const DraftWorkflowBlock = ({
  assignment,
  isDetailsPage,
}: DraftBlockProps) => {
  const fetchDrafts = useSetAtom(fetchDraftsActionAtom);
  const createDraft = useSetAtom(createDraftActionAtom);

  const assignmentDrafts = useAtomValue(assignmentDraftsAtom);

  const drafts = assignmentDrafts[assignment.id] || [];

  const draftsLoading = useAtomValue(draftsLoadingAtom);

  const handleFetchDrafts = async () => {
    await fetchDrafts(assignment.id);
  };

  const handleCreateDraft = async () => {
    await createDraft(assignment.id);
  };

  useEffect(() => {
    if (drafts.length === 0) {
      handleFetchDrafts();
    }
  }, [drafts.length]);

  if (!assignment.personaId && drafts.length === 0) {
    return null;
  }

  return (
    <div className='space-y-3'>
      <WorkflowButton
        disabled={draftsLoading}
        className='w-full'
        onClick={handleCreateDraft}
        isContentGenerated={drafts.length > 0}
        Icon={FileAudio}
        title={drafts.length > 0 ? 'Drafts' : 'Create Draft'}
      />

      {isDetailsPage && <Drafts assignmentId={assignment.id} drafts={drafts} />}
    </div>
  );
};
